<template>
  <div class="no-bids d-flex align-center justify-center">
    <div class="text-center">
      <v-img class="mb-6 mx-auto" src="@/assets/img/docs.png" width="72px"></v-img>
      <h3 class="font font--h3 mb-2">У вас нет доступа для просмотра заявок</h3>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style lang="scss" scoped>
.no-bids {
  min-height: 350px;
}
</style>
